import { createSlice } from '@reduxjs/toolkit'

const wizardSlice = createSlice({
  name: 'onboardingWizardSlice',
  initialState: {
    isFreeEmail: null,
    hasSeenModalCurrentSession: null,
    showReminderSpotlight: false,
  },
  reducers: {
    setIsFreeEmailUser: (state, { payload }) => {
      state.isFreeEmail = payload
    },
    clearOnboardingValues: (state) => {
      state.isFreeEmail = null
      state.hasSeenModalCurrentSession = null
    },
    showReminderSpotlight: (state) => {
      state.showReminderSpotlight = true
    },
    clearReminderSpotlight: (state) => {
      state.showReminderSpotlight = false
    },
  },
})

export const {
  reducer,
  actions: {
    setIsFreeEmailUser,
    showReminderSpotlight,
    clearReminderSpotlight,
  },
} = wizardSlice
